module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page greyBg"
  }, [_c('pageTitle', {
    attrs: {
      "title": "完善个人信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "userMsg"
  }, [_c('img', {
    attrs: {
      "src": _vm.oauth.headUrl
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.oauth.nickName) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "whiteBg main"
  }, [(_vm.needRegist) ? _c('mu-text-field', {
    attrs: {
      "errorText": _vm.nameErr,
      "label": "姓名",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.nameChange
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.needRegist) ? _c('mu-text-field', {
    attrs: {
      "errorText": _vm.usernameErr,
      "label": "卡号/手机号/邮箱",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.userNameChange
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.needRegist) ? _c('mu-text-field', {
    attrs: {
      "errorText": _vm.phoneErr,
      "label": "手机号",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.phoneChange
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.needRegist) ? _c('mu-text-field', {
    attrs: {
      "errorText": _vm.idnoErr,
      "label": "身份证号",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.idnoChange
    },
    model: {
      value: (_vm.idno),
      callback: function($$v) {
        _vm.idno = $$v
      },
      expression: "idno"
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "type": "password",
      "errorText": _vm.passwordErr,
      "label": "密码",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.passwordChange
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), (_vm.needRegist) ? _c('mu-text-field', {
    attrs: {
      "type": "password",
      "errorText": _vm.rePasswordErr,
      "label": "确认密码",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.rePasswordChange
    },
    model: {
      value: (_vm.rePassword),
      callback: function($$v) {
        _vm.rePassword = $$v
      },
      expression: "rePassword"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('mu-text-field', {
    attrs: {
      "errorText": _vm.imgCodeErr,
      "label": "图片验证码",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.imgCodeChange
    },
    model: {
      value: (_vm.imgCode),
      callback: function($$v) {
        _vm.imgCode = $$v
      },
      expression: "imgCode"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "27%",
      "margin-left": "2%",
      "margin-bottom": "-2%"
    },
    attrs: {
      "src": this.TPFJM
    },
    on: {
      "click": this.getValidateCode
    }
  })], 1), _vm._v(" "), (_vm.needRegist) ? _c('div', {
    staticClass: "relative"
  }, [_c('mu-text-field', {
    attrs: {
      "errorText": _vm.phoneCodeErr,
      "label": "手机验证码",
      "labelFloat": "",
      "fullWidth": true
    },
    on: {
      "blur": _vm.phoneCodeChange
    },
    model: {
      value: (_vm.phoneCode),
      callback: function($$v) {
        _vm.phoneCode = $$v
      },
      expression: "phoneCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mu-raised-button', {
    style: ({
      height: '30px'
    }),
    attrs: {
      "label": "获取验证码",
      "primary": ""
    },
    on: {
      "click": _vm.sendSMS
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btn",
    style: ({
      height: '50px'
    }),
    attrs: {
      "label": _vm.btnMsg,
      "fullWidth": true,
      "primary": ""
    },
    on: {
      "click": _vm.doBind
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bintHint",
    on: {
      "click": _vm.changeBindType
    }
  }, [_vm._v(_vm._s(_vm.changeMsg))])], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.hintMsg,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('pop', {
    attrs: {
      "display": _vm.popDisplay,
      "title": "提示",
      "msg": _vm.popMsg,
      "onlyOk": _vm.popOnlyOk
    },
    on: {
      "closeHandler": _vm.closePop,
      "okHandler": _vm.closePop
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da961b68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uniteLogin/bindAccount.vue
// module id = 1599
// module chunks = 18